import { ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    addingNewEntry: boolean;
    handleReset: () => void;
    handleDelete: () => void;
    onBack?: () => void;
}

export const NeedEventModalSecondaryButton: FunctionComponent<IProps> = ({ addingNewEntry, handleReset, handleDelete, onBack }) => {
    const { t } = useTranslation();

    if (onBack) {
        return (
            <ZfTextButton hierarchy="tertiary" type="reset" size="medium" onClick={() => onBack()}>
                {t('back')}
            </ZfTextButton>
        );
    } else if (addingNewEntry) {
        return (
            <ZfTextButton hierarchy="tertiary" type="reset" size="medium" onClick={handleReset}>
                {t('sessionFilterReset')}
            </ZfTextButton>
        );
    } else {
        return (
            <ZfTextButton hierarchy="tertiary" type="button" kind="destructive" onClick={handleDelete}>
                {t('eventModalDeleteButton')}
            </ZfTextButton>
        );
    }
};
